
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import { TCModel } from "@iabtechlabtcf/core";

@Component
export default class LayerOne extends Vue {
	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = gGDPR_logoURL;

	mounted(): void {
		if (gGDPR_privacyPolicyURL)
      this.privacyPageURL = gGDPR_privacyPolicyURL;
	}

  @Emit("changeViewEvent")
	continueToSiteClick() {
		return( "close");
	}
}
